// Get username from email (for display only)
export const getUsernameFromEmail = (email) => {
  if (!email) return 'N/A';
  return email.split('@')[0];
};

// Get role display name
export const getRoleDisplayName = (role) => {
  switch(role) {
    case 'superadmin': return 'Super Admin';
    case 'admin': return 'Admin';
    case 'user': return 'User';
    default: return role;
  }
};

// Get role color class
export const getRoleColor = (role) => {
  switch(role) {
    case 'superadmin': return 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200';
    case 'admin': return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200';
    case 'user': return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200';
    default: return 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200';
  }
};

// Get company names for display
export const getCompanyNames = (userCompanies) => {
  if (!userCompanies || userCompanies.length === 0) {
    return 'None';
  }
  return userCompanies.map(c => c.name).join(', ');
};

// Get managed user names for display
export const getManagedUserNames = (user) => {
  if (user.role !== 'admin' && user.role !== 'superadmin') {
    return 'N/A';
  }
  
  if (!user.managed_users || user.managed_users.length === 0) {
    return 'None';
  }
  
  return user.managed_users.map(u => u.email).join(', ');
};

// Get managed user count for display
export const getManagedUserCount = (user) => {
  if (user.role !== 'admin' && user.role !== 'superadmin') {
    return '-';
  }
  return user.managed_users?.length || 0;
};